import {
    type ApproveProfileUpdateRequestResponseType,
    type ApproveProfileUpdateRequestRequestType
} from "./type";
import {
    request
} from "../request";

const approveProfileUpdateRequest = async (
    params: ApproveProfileUpdateRequestRequestType
): Promise<ApproveProfileUpdateRequestResponseType> => {
    return await request<ApproveProfileUpdateRequestResponseType>(
        "/request/approveProfileUpdateRequest",
        {
            body: JSON.stringify(params),
            method: "POST"
        }
    );
};
export default approveProfileUpdateRequest;
